module.exports = __webpack_public_path__ + "static/media/approved.0d980322.svg";